<template>
  <div class="bg-light pt-3 pt-lg-5 pb-5">
    <b-container fluid>
      <b-row>
        <b-col cols="12" lg="3" xl="2" class="p-0">
          <DashUserNav />
        </b-col>

        <b-col cols="12" lg="9" xl="10" class="pl-3 pl-lg-3 mt-3">

           <div v-if="userData.data._id">
              <Books page-title="Minhas Reservas" :user-id="userData.data._id" />
           </div>

        </b-col>
      </b-row>
    </b-container>

  </div>
</template>

<script>
    import DashUserNav from "@/components/DashUserNav";
    import Books from "@/views/dashboard/owner-panel/Books";
    import UserService from "@/services/user.service";


    export default {

        name: 'MyReservations',
        components: {
            DashUserNav,
            Books
        },
        data() {
            return {
               user: {}
            }
        },
        async mounted() {
           if (!this.userData.data._id) await this.getUser();
           this.user = this.userData.data

           if (!this.currentUser) {
              await this.$router.push('/login')
           }
        },
        methods: {
           //Obtem os dados do usuário.
           async getUser() {
              await this.$store.dispatch('user/get', await UserService.getUserData())
           },
        },
        computed: {
           currentUser() {
              return this.$store.state.auth.user;
           },
           userData() {
              return this.$store.state.user
           }
        },
        watch: {

        }
    };
</script>
